import {url} from "../helpers";
import store from "./store";

export default function useGlobal() {
    const token = document.querySelector('meta[name=csrf-token]').content

    async function getData(dispatchMethod, commitName) {
        await store.dispatch(dispatchMethod)
            .then(response => {
                store.commit(commitName, response.data)
            })
    }

    return {
        getData,
        url,
        token
    }
}
